<template>
  <v-container flat fluid>
    <v-card>
      <v-card-title class="primary white--text">
        <span class="title">
          {{ type == 'Client' ? 'Extra Information' : 'Qualifications & Licenses' }}
          <v-tooltip right color="secondary" transition="slide-x-transition">
            <template v-slot:activator="{ on }">
              <font-awesome-icon
                v-on="on"
                icon="question-circle"
                class="ml-1"
                :style="{ color: '#2196F3' }"
              />
            </template>
            <span>+ any additional information you would like to save</span>
          </v-tooltip>
        </span>
        <v-spacer></v-spacer>
        <v-btn
          fab
          x-small
          color="blue"
          @click="newAttribute"
          :disabled="!canAddAttribute"
          :dark="canAddAttribute"
        >
          <font-awesome-icon size="lg" icon="plus" />
        </v-btn>
      </v-card-title>

      <v-form>
        <v-container flat fluid>
          <v-row v-for="(attr, index) in obj.attributes" :key="index" no-gutters>
            <v-col>
              <v-row>
                <v-col cols="12" sm="6" :md="template ? '4' : '3'">
                  <v-text-field
                    v-model="attr.label"
                    label="Description"
                    outlined
                    filled
                    hide-details
                    autocomplete="off"
                    :readonly="attr._id != null"
                  ></v-text-field>
                </v-col>
                <v-col
                  cols="12"
                  sm="6"
                  :md="template ? '3' : '2'"
                  v-if="!attr.createdAt || template"
                >
                  <v-select
                    v-model="attr.type"
                    :items="attributeDataTypeItems"
                    label="Type"
                    outlined
                    filled
                    hide-details
                  ></v-select>
                </v-col>
                <v-col cols="12" sm="6" :md="template ? '3' : '2'" v-if="attr.type == 'Date'">
                  <v-select
                    v-model="attr.reminder"
                    :items="reminderItems"
                    label="Reminder"
                    outlined
                    filled
                    hide-details
                  ></v-select>
                </v-col>
                <v-col cols="12" sm="6" md="3" v-if="!template">
                  <v-autocomplete
                    v-if="attr.type == 'Array'"
                    v-model="attr.attribute"
                    :items="attr.values"
                    label="Select values"
                    outlined
                    filled
                    hide-details
                    multiple
                  >
                    <template v-slot:selection="{ item, index }">
                      <v-chip close small v-if="index < 5" @click:close="remove(attr, index)">
                        <span>{{ item }}</span>
                      </v-chip>
                      <span
                        v-if="index === 5"
                        class="grey--text caption"
                      >(+{{ attr.attribute.length - 5 }} others)</span>
                    </template>
                  </v-autocomplete>
                  <v-text-field
                    v-if="attr.type != 'Date' && attr.type != 'Array'"
                    v-model="attr.attribute"
                    label="Value"
                    outlined
                    filled
                    hide-details
                    autocomplete="off"
                  ></v-text-field>
                  <date
                    v-if="attr.type == 'Date'"
                    v-model="attr.attribute"
                    :style="'width:120px;float:left'"
                    label="Expiry Date"
                  ></date>
                </v-col>
                <v-col cols="12" sm="6" md="3" v-if="template && attr.type == 'Array'">
                  <list-string :items="attr.values"></list-string>
                </v-col>
                <v-col cols="2">
                  <v-checkbox v-model="attr.required" :readonly="!template" label="Required"></v-checkbox>
                </v-col>
              </v-row>
            </v-col>
            <v-col style="max-width:25px" align-self="center" v-if="template || !attr.required">
              <v-icon @click="removeAttribute(index)" class>mdi-minus-circle</v-icon>
            </v-col>
          </v-row>
        </v-container>
      </v-form>
    </v-card>
  </v-container>
</template>

<script>
import listString from "@/components/listString";
import date from "@/components/date";

export default {
  props: {
    obj: Object,
    template: Boolean,
    type: String
  },
  components: {
    listString,
    date
  },
  data() {
    return {
      attributeDataTypeItems: ["Text", "Number", "Date", "Array", "Boolean"],
      reminderItems: [
        "None",
        "Expired",
        "< 1 Week",
        "< 2 Weeks",
        "< 1 Month",
        "< 2 Months",
        "< 3 Months",
        "< 6 Months"
      ]
    };
  },
  computed: {
    canAddAttribute() {
      return this.template
        ? this.canAddToArray(this.obj.attributes, ["label", "type"])
        : this.canAddToArray(this.obj.attributes, ["attribute", "type"]);
    }
  },
  methods: {
    checkForData() {
      if (!this.obj.attributes) {
        this.$set(this.obj, "attributes", []);
        this.newAttribute();
      }
    },
    newAttribute() {
      this.template
        ? this.obj.attributes.push({
            label: null,
            type: null,
            values: [],
            required: false
          })
        : this.obj.attributes.push({
            label: null,
            type: null,
            attribute: null
          });
    },
    removeAttribute(index) {
      this.obj.attributes.splice(index, 1);
    },
    remove(attr, index) {
      attr.attribute.splice(index, 1);
    }
  },
  mounted() {
    this.checkForData();
  }
};
</script>
